// Map fixture errors (thrown by data mutators) to axios-shaped demo rejections.

import { demoError } from '../core';
import { DemoApprovalError } from '../data/approvals';
import { DemoUserError } from '../data/users';

export function guarded<T>(fn: () => T): T | Promise<never> {
  try {
    return fn();
  } catch (error) {
    if (error instanceof DemoApprovalError || error instanceof DemoUserError) {
      return demoError(error.status, error.message);
    }
    throw error;
  }
}

export function str(value: unknown): string | undefined {
  const v = Array.isArray(value) ? value[0] : value;
  return typeof v === 'string' && v !== '' ? v : typeof v === 'number' ? String(v) : undefined;
}

export function body<T>(raw: unknown): T {
  return (raw && typeof raw === 'object' ? raw : {}) as T;
}
